import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../modules/infra/i18n';

const InstagramAuth = ({ linked, deauthorize, authorize, wrapperClass, isLoading }) => (
  <div className={wrapperClass}>
    <div className="c-label-new">{t('settings:instagram_auth.link_instagram')}</div>
    {!linked ? (
      <button type="button" className="c-btn c-btn--small" onClick={authorize} disabled={isLoading}>
        {t('settings:instagram_auth.link_button')}
      </button>
    ) : (
      <button type="button" className="c-btn c-btn--small" onClick={deauthorize} disabled={isLoading}>
        {t('settings:instagram_auth.unlink_button')}
      </button>
    )}
  </div>
);

InstagramAuth.propTypes = {
  linked: PropTypes.bool,
  deauthorize: PropTypes.func.isRequired,
  authorize: PropTypes.func.isRequired,
  wrapperClass: PropTypes.string,
  isLoading: PropTypes.bool,
};

InstagramAuth.defaultProps = {
  linked: false,
  wrapperClass: '',
  isLoading: false,
};

export default InstagramAuth;
